import React from 'react'
import { graphql } from 'gatsby'

import type { MediaComponent, DrupalMediaBase } from './types'

export interface VideoFile {
	fid: number
	type: string
	src: {
		url: string
	}
}

export interface MediaVideoFile extends DrupalMediaBase {
	__typename: 'media__video_file'
	mid: number
	relationships: {
		file: VideoFile[]
		poster?: {
			localFile: {
				url: string
			}
		}
	}
}

const MediaVideoFileComponent: MediaComponent<MediaVideoFile> = ({ className, media, title }) => (
	<video
		className={className}
		autoPlay
		loop
		muted
		poster={media.relationships.poster?.localFile.url}
		title={title}
	>
		{media.relationships.file.map(file => (
			<source key={file.fid} type={file.type} src={file.src.url} />
		))}
	</video>
)

export default MediaVideoFileComponent

export const query = graphql`
	fragment MediaVideoFile on media__video_file {
		__typename
		mid: drupal_internal__mid
		relationships {
			poster: field_media_image {
				localFile {
					url
				}
			}
			file: field_media_video_file {
				fid: drupal_internal__fid
				type: filemime
				src: uri {
					url
				}
			}
		}
	}
`
